"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _style = require("webmotors-react-pj/button/style.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = props => {
  const {
    tag = 'button',
    type = 'submit',
    size = 'small',
    token = 'primary',
    icon,
    children,
    iconStart = false
  } = props;
  const propsCustom = _objectSpread({}, props);
  ['tag', 'token', 'icon', 'size'].forEach(item => delete propsCustom[item]);
  const IconElement = () => _react.default.createElement(_style.StyleIcon, {
    iconStart: iconStart,
    token: token
  }, icon);
  return (0, _react.createElement)((0, _style.StyleElement)({
    tag,
    token,
    size
  }), _objectSpread({}, propsCustom), _react.default.createElement(_react.Fragment, null, icon && iconStart && _react.default.createElement(IconElement, null), children, icon && !iconStart && _react.default.createElement(IconElement, null)));
};
exports.default = _default;